"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleSetup = void 0;
class ModuleSetup {
    constructor(config) {
        this.config = config;
    }
    render(children) {
        return children;
    }
}
exports.ModuleSetup = ModuleSetup;
// eslint-disable-next-line @typescript-eslint/naming-convention -- To detect ModuleSetup classes
ModuleSetup.__secret__LATTICE_SETUP = true;
//# sourceMappingURL=ModuleSetup.js.map